window.okeReviewsCarouselOnInit = function() {
  const carouselElement = document.querySelector('.js-okeReviews-reviewsCarousel-slider');
  if (carouselElement) {
    var carousel = carouselElement.okeCarousel;
    if (carousel) {
      carousel.onClick(function (e) { carousel.select(e.index); });
    }
  }
  
  $('.okeReviews-reviewsCarousel-review').each(function(e,i){    
    var review = i;           
    var reviewProductNameElement = $(review).find('.okeReviews-reviewsCarousel-review-product-name');       	
    $(reviewProductNameElement).addClass('link f5 fw7 near-black button button-dark relative tracked ttu brandon')
    $(reviewProductNameElement).css('font-size','14px');
    $(reviewProductNameElement).removeClass('okeReviews-reviewsCarousel-review-product-name')
    
    var reviewProductName = $(reviewProductNameElement).html();
    var reviewProductNameInnerSpan = document.createElement('span');    
    reviewProductNameInnerSpan.className = 'relative z-1 center';
    reviewProductNameInnerSpan.innerHTML = reviewProductName;    
    $(reviewProductNameElement).html('');    
    
    reviewProductNameElement.append(reviewProductNameInnerSpan);
  });   
};
